import { Cookies } from 'quasar'
import { axiosInstance } from './axios'

export default async ({ store }) => {
  if (Cookies.has('auth_token')) {
    store.commit('auth/isAuthenticated', true)
    axiosInstance.defaults.headers.common['Authorization'] =
      'Bearer ' + Cookies.get('auth_token')
  }
}
